<template>
    <div>
        <CCol sm="12">
            <img src="../assets/img/arrow-left.png" style="max-width:18px;" class="float-left" @click="GoToSettingProfile()"/>
            <h3 class="custom-18px-500 font-color-171717" style="padding-left: 25px;">Back</h3>
        </CCol>
        <CCol sm="12">
            
            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                <div>
                    <div class="p-2">
                        <CRow>
                            <CCol sm="10">
                                <h3 class="custom-18px-500 font-color-171717">Claim Policies</h3>
                            </CCol>
                            <CCol sm="2">
                                <CButton class="btn-border-blue font-color-0B63F6" @click="openAddSubs"><img src="../assets/img/add-circle.png" style="max-width:20px" class="mr-1" />Download</CButton>
                            </CCol>
                        </CRow>
                                    <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                                        <div>
                                            <v-client-table :data="allTableData" :columns="columns" :options="options" class="custom-table" v-if="allTableData.length > 0">
                                                <template v-slot:No="{ row }">
                                                                        <label class="custom-12px-500">{{ row.No }}</label>
                                            </template>

                                            <template v-slot:Title="{ row }">
                                                <label class="custom-12px-500">{{ row.Title }}</label>
                                            </template>

                                            <template v-slot:Status="{ row }">
                                                <label class="custom-12px-500 bg-F2F4F7 font-color-0B63F6">{{ row.Status }}</label>
                                            </template>

                                            <template v-slot:Announcer="{ row }">
                                                <label class="custom-12px-500">{{ row.Status }}</label>
                                            </template>

                                            <template v-slot:Created Date="{ row }">
                                                <label class="custom-12px-500">{{ row.CreatedDate }}</label>
                                            </template>

                                            <template v-slot:Updated Date="{ row }">
                                                <label class="custom-12px-500">{{ row.UpdatedDate }}</label>
                                            </template>

                                            <template v-slot:Action="{ row }">
                                                <div class="d-flex">
                                                    <img :src="require('@/assets/img/set-edit.png')" alt="View" style="cursor: pointer;width:30px" @click="viewRow(row.Index)" class="ml-2" />
                                                </div>
                                            </template>
                                            <template v-slot:Include="{ row }">
                                                <div class="d-flex">
                                                    <CCol sm="2">
                                                        <CSwitch class="float-right mt-1" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                                    </CCol>
                                                </div>
                                            </template>
                                                        </v-client-table>
                                                        <div v-else class="no-data-message text-center" style="margin:10%">
                                                <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;"/>
                                                <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
                                                <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
                                                </div>
                                        </div>
                   

                </CCard>
    
                    </div>
                </div>
    
                </CCard>
            </CCol>
    
        </CCol>
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {
            user: {},
            detailStaff: {},
            columns: [
                'ClaimType',
                'AnualLimit',
                'Balance',
                'Remarks',
                'Action',
                'Include'
            ],
            allTableData: [
                { ClaimType: 'Flight Ticket', AnualLimit: 'Unlimited', 'Balance': 'Unlimited', 'Remarks': 'N/A' },
                { ClaimType: 'Parking', AnualLimit: 'Unlimited', 'Balance': 'Unlimited', 'Remarks': 'N/A' },
                { ClaimType: 'Abidin Samad', AnualLimit: 'Unlimited', 'Balance': 'Unlimited', 'Remarks': 'N/A' }
            ],
            options: {
                perPage: 5,
                pagination: false,
                searchable: false,
                filterable: false,
            },

        }





    },
    async mounted() {
        await this.GetListDetailStaff();
        await this.GetInfoUser();

    },

    computed: {

    },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        async GetListDetailStaff(id) {
            try {
                console.log("id" + id);
                const response = await this.$API.get(this.$GetStaffDetails + "?id=" + this.$route.query.id, {
                    withCredentials: true,
                });
                if (response.status === 200) {

                    this.detailStaff = response.data;

                } else {
                    console.error("Failed to fetch information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
            }
        },
        async GoToSettingProfile(pageName = "SettingProfile") {
            let id = this.$route.query.id; // Retrieve the `id` from the current route

            if (!id) {
                console.warn("ID is missing in the query parameters!");

                // Fetch the user ID using GetInfoUser method
                try {
                    await this.GetInfoUser(); // Call GetInfoUser to populate `this.user`
                    id = this.user?.id; // Assume `this.user` contains `id` after fetching

                    if (!id) {
                        console.error("Unable to retrieve user ID from user information.");
                        alert("An error occurred. Please log in again.");
                        return this.$router.push({ path: "/Login" }); // Redirect to login if ID is missing
                    }
                } catch (error) {
                    console.error("Error retrieving user ID:", error);
                    alert("An error occurred. Please log in again.");
                    return this.$router.push({ path: "/Login" });
                }
            }

            // Navigate to the specified page with the resolved `id` as query parameter
            this.$router.push({ name: pageName, query: { id } });
        },


    }

};
</script>